// extracted by mini-css-extract-plugin
export default {"container":"DialogFooterGroupItem--container--767cba","regular":"DialogFooterGroupItem--regular--2557e6","critical":"DialogFooterGroupItem--critical--2ccfc8"};